module.exports = __webpack_public_path__ + "static/media/cert_91.ea675f94.jpg";